import script from "./vip.vue?vue&type=script&setup=true&lang=ts"
export * from "./vip.vue?vue&type=script&setup=true&lang=ts"

import "./vip.vue?vue&type=style&index=0&id=1d4f62e8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d4f62e8"]])

export default __exports__